import React from "react";

import { Link } from "react-router-dom";

const ALREADY_TAKEN_PATTERNS = [
  "property is already added by someone",
  "property is already added by another user",
];

export const isPropertyAlreadyTakenError = (message) => {
  if (!message || typeof message !== "string") {
    return false;
  }
  const normalized = message.toLowerCase();
  return ALREADY_TAKEN_PATTERNS.some((pattern) =>
    normalized.includes(pattern),
  );
};

const PropertySearchErrorMessage = ({
  message,
  className = "text-center text-danger m-3",
  linkClassName = "text-secondary hover:underline font-medium",
}) => {
  if (!message) {
    return null;
  }

  return (
    <p className={className}>
      {message}
      {isPropertyAlreadyTakenError(message) && (
        <>
          {" "}
          If this is your property, please{" "}
          <Link to="/login" className={linkClassName}>
            log in
          </Link>{" "}
          to your account.
        </>
      )}
    </p>
  );
};

export default PropertySearchErrorMessage;
